import { useTranslation } from '@hbs-us/ui';

import { StatusBadge, type StatusTone } from '../../_money/StatusBadge.js';
import type { EmployeeListItemDto } from '../contractsMirror.js';

/**
 * The employee status badge (Shared 6 tone system). The meaning is ALWAYS carried
 * by the badge TEXT (Active / Inactive / Archived), never color alone (A11Y-01); the
 * `tone` resolves to locked `@hbs-us/ui` semantic tokens — NO hardcoded hex (BRAND-06).
 *
 * An employee is Archived when `archivedAt` is set (out of the working list), else
 * Active or Inactive per the `active` flag (an inactive-but-not-archived employee
 * stays in the directory but is excluded from new work assignment, legacy parity).
 */
export function EmployeeStatusBadge({ employee }: { employee: EmployeeListItemDto }) {
  const { t } = useTranslation();

  let tone: StatusTone;
  let labelKey: string;
  if (employee.archivedAt) {
    tone = 'neutral';
    labelKey = 'employees:status.archived';
  } else if (employee.active) {
    tone = 'success';
    labelKey = 'employees:status.active';
  } else {
    tone = 'warning';
    labelKey = 'employees:status.inactive';
  }

  return <StatusBadge tone={tone}>{t(labelKey)}</StatusBadge>;
}
